function getSliderSettings() {
  return {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };
}

function getSubSliderProductSettings() {
  return {
    slidesPerView: "auto",
    direction: "vertical",
    navigation: false,
  };
}

const sliderInit = (isUpdate) => {
  if (
    document.querySelectorAll(".js-media-list") &&
    document.querySelectorAll(".js-media-list").length > 0
  ) {
    const _mediaParam = new URLSearchParams(window.location.search).get(
      "media",
    );
    document.querySelectorAll(".js-media-list").forEach((elem, index) => {
      let _initialSlide = 0;
      if (_mediaParam) {
        const _found = Array.from(
          elem.querySelectorAll(".swiper-slide[data-media-id]"),
        ).findIndex(function (slide) {
          const m = (slide.getAttribute("data-media-id") || "").match(/(\d+)$/);
          return m && m[1] === _mediaParam;
        });
        if (_found >= 0) _initialSlide = _found;
      }
      let slider = new Swiper(elem, {
        initialSlide: _initialSlide,
        slidesPerView: 1,
        spaceBetween: 2,
        autoHeight: true,
        navigation: false,
        thumbs: {
          swiper: document.querySelectorAll(".js-media-sublist")[index].swiper,
        },
        on: {
          afterInit: function () {
            setTimeout(() => {
              /* Set fixed slider height */
              document.querySelectorAll(".product .product__media-list")[
                index
              ].style.minHeight =
                `${document.querySelectorAll(".product .product__media-list")[index].offsetHeight}px`;
              if (typeof window.applyMediaParam === "function")
                window.applyMediaParam();
            }, 100);
          },
          slideChangeTransitionStart: function () {
            document
              .querySelectorAll(".js-media-sublist")
              [
                index
              ].swiper.slideTo(document.querySelectorAll(".js-media-list")[index].swiper.activeIndex);
          },
          slideChange: function () {
            window.pauseAllMedia();
            this.params.noSwiping = false;
            try {
              const slide = this.slides[this.activeIndex];
              const dataId = slide && slide.getAttribute("data-media-id");
              const m = dataId && dataId.match(/(\d+)$/);
              if (m) {
                const url = new URL(window.location.href);
                url.searchParams.set("media", m[1]);
                history.replaceState(null, "", url.toString());
              }
            } catch (_) {}
          },
          slideChangeTransitionEnd: function () {
            const activeSlide = this.slides[this.activeIndex];
            if (activeSlide && activeSlide.querySelector("model-viewer")) {
              activeSlide
                .querySelector(".shopify-model-viewer-ui__button--poster")
                .removeAttribute("hidden");
            }
          },
          touchStart: function () {
            if (
              this.slides[this.activeIndex] &&
              this.slides[this.activeIndex].querySelector("model-viewer")
            ) {
              if (
                !this.slides[this.activeIndex]
                  .querySelector("model-viewer")
                  .classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            } else {
              this.params.noSwiping = false;
            }
          },
        },
      });

      if (isUpdate) {
        setTimeout(function () {
          slider.update();
        }, 800);
      }
    });
  }
};

const subSliderInit = (isUpdate) => {
  if (
    document.querySelectorAll(".js-media-sublist") &&
    document.querySelectorAll(".js-media-sublist").length > 0
  ) {
    const _mediaParam = new URLSearchParams(window.location.search).get(
      "media",
    );
    document.querySelectorAll(".js-media-sublist").forEach((elem, index) => {
      let _initialSlide = 0;
      if (_mediaParam) {
        const _found = Array.from(
          elem.querySelectorAll(".swiper-slide[data-media-id]"),
        ).findIndex(function (slide) {
          const m = (slide.getAttribute("data-media-id") || "").match(/(\d+)$/);
          return m && m[1] === _mediaParam;
        });
        if (_found >= 0) _initialSlide = _found;
      }
      let subSlider = new Swiper(elem, {
        initialSlide: _initialSlide,
        centeredSlides: true,
        centeredSlidesBounds: true,
        slidesPerView: 3,
        spaceBetween: 8,
        direction: "horizontal",
        navigation: {
          nextEl: ".product__button-next",
          prevEl: ".product__button-prev",
        },
        freeMode: false,
        watchSlidesProgress: true,
        on: {
          afterInit: function () {
            this.params.slidesPerView =
              this.slides &&
              this.slides.length === 2 &&
              window.matchMedia("(min-width: 1200px)").matches
                ? 2
                : 3;

            setTimeout(() => {
              /* Set fixed slider height */
              document.querySelectorAll(".product .product__media-sublist")[
                index
              ].style.minHeight =
                `${document.querySelectorAll(".product .product__media-sublist")[index].offsetHeight}px`;
            }, 100);
          },
          touchEnd: function (s, e) {
            let range = 5;
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY);
            if (diff < range || diff > -range) s.allowClick = true;
          },
        },
        transitionStart: function () {
          document
            .querySelector(".js-media-list")
            .swiper.slideTo(
              document.querySelectorAll(".js-media-sublist")[index].swiper
                .activeIndex,
            );
        },
        breakpoints: {
          1200: {
            direction: "vertical",
          },
        },
      });

      if (isUpdate) {
        setTimeout(function () {
          subSlider.update();
        }, 800);
      }
    });
  }
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    try {
      video.contentWindow?.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*",
      );
    } catch (_) {}
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    try {
      video.contentWindow?.postMessage('{"method":"pause"}', "*");
    } catch (_) {}
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus && !elementToFocus.classList.contains("card-focused"))
    elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.isFractional = this.dataset.fractional === "true";

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
    var eventList = ["paste", "input"];

    for (event of eventList) {
      this.input.addEventListener(event, (e) => {
        // ========== Fractional input =============
        if (this.isFractional) {
          const raw = String(e.currentTarget.value).replace(",", ".");
          // allow live typing, but sanitize to a decimmal
          if (!/^\d*(?:[\.]\d*)?$/.test(raw)) {
            e.currentTarget.value = this.input.min || "0.5";
          } else if (e.type === "paste") {
            // const n = parseFloat(raw);
            // if (Number.isFinite(n)) {
            // 	let snapped = Math.round(n * 4) / 4;
            // 	snapped = Number(snapped.toFixed(2));
            // 	if (snapped < 0.5) snapped = 0.5;
            // 	e.currentTarget.value = String(snapped);
            // }
          }
        } else {
          const numberRegex = /^0*?[1-9]\d*$/;
          if (
            numberRegex.test(e.currentTarget.value) ||
            e.currentTarget.value === ""
          ) {
            e.currentTarget.value;
          } else {
            e.currentTarget.value = 1;
          }
        }
      });
    }

    // Clamp fractional value on change (before event bubbles) - handles Enter key before focusout
    this.input.addEventListener(
      "change",
      (e) => {
        if (this.isFractional) {
          const raw = String(e.currentTarget.value).replace(",", ".");
          const n = parseFloat(raw);
          const upy = parseFloat(
            String(this.input.dataset.unitsPerYard || "").replace(",", "."),
          );
          const stepYards = Number.isFinite(upy) && upy > 0 ? 1 / upy : 0.25;
          const minYards = stepYards >= 1 ? stepYards : 0.5;
          if (Number.isFinite(n) && n < minYards) {
            e.currentTarget.value = String(minYards);
          }
        }
      },
      true,
    );

    this.input.addEventListener("focusout", (e) => {
      // ========== Fractional input =============
      if (this.isFractional) {
        const raw = String(e.currentTarget.value).replace(",", ".");
        let n = parseFloat(raw);
        const upy = parseFloat(
          String(this.input.dataset.unitsPerYard || "").replace(",", "."),
        );
        const stepYards = Number.isFinite(upy) && upy > 0 ? 1 / upy : 0.25;
        const minYards = stepYards >= 1 ? stepYards : 0.5;
        if (!Number.isFinite(n)) n = minYards;
        // Snap to nearest step (1 unit worth of yards)
        let snapped = Math.round(n / stepYards) * stepYards;
        snapped = Number(snapped.toFixed(2));
        if (snapped < minYards) snapped = minYards;
        e.currentTarget.value = String(snapped);
      } else {
        if (e.currentTarget.value === "") {
          e.currentTarget.value = 1;
        }
      }
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    // Fractional branch
    if (this.isFractional) {
      if (typeof event.preventDefault === "function") event.preventDefault();
      if (typeof event.stopPropagation === "function") event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function")
        event.stopImmediatePropagation();
      const upy = parseFloat(
        String(this.input.dataset.unitsPerYard || "").replace(",", "."),
      );
      const stepYards = Number.isFinite(upy) && upy > 0 ? 1 / upy : 0.25;
      const parseNumber = (v) => {
        const n = parseFloat(String(v).replace(",", "."));
        return isNaN(n) ? 0 : n;
      };
      const clamp = (val, min, max) => {
        const minNum =
          min !== undefined && min !== null && min !== ""
            ? parseFloat(min)
            : undefined;
        const maxNum =
          max !== undefined && max !== null && max !== ""
            ? parseFloat(max)
            : undefined;
        if (Number.isFinite(minNum)) val = Math.max(val, minNum);
        if (Number.isFinite(maxNum)) val = Math.min(val, maxNum);
        return val;
      };
      const name =
        (event.currentTarget && event.currentTarget.name) || event.target.name;
      let base = this.input.value;
      if (base === undefined || base === null || base === "")
        base = this.input.min;
      if (base === undefined || base === null || base === "")
        base = stepYards >= 1 ? stepYards : 0.5;
      let newVal = parseNumber(base);
      if (name === "plus") {
        newVal = newVal + 1;
      } else {
        newVal = newVal - stepYards;
      }
      newVal = clamp(newVal, this.input.min, this.input.max);
      // Round to nearest step (1 unit worth of yards)
      newVal = Math.round(newVal / stepYards) * stepYards;
      newVal = Number(newVal.toFixed(2));
      this.input.value = String(newVal);
      this.input.dispatchEvent(new Event("input", { bubbles: true }));
      if (String(previousValue) !== String(this.input.value)) {
        this.input.dispatchEvent(this.changeEvent);
      }
      return;
    }

    const name =
      (event.currentTarget && event.currentTarget.name) || event.target.name;
    name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`,
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) => {
      if (this.querySelector(".toggle-scheme-button") === button) return;
      if (this.querySelector(".header__localization-button") === button) return;
      if (this.querySelector(".header__localization-lang-button") === button)
        return;
      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`,
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    let isOpen = false;

    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    document.querySelectorAll("body > quick-add-modal").forEach((el) => {
      if (el.hasAttribute("open")) {
        isOpen = true;
      }
    });

    if (!isOpen) {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
    }
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this),
    );
    if (this.getAttribute("data-autoplay")) {
      this.loadContent();
    }
  }

  /**
   * Prevent Swiper pointer handling and premature clicks on the embed while the iframe
   * document is still loading (avoids a broken YouTube/Vimeo state on the main carousel).
   */
  attachIframeCarouselShield(iframe) {
    if (!iframe.closest(".js-media-list") || !this.classList.contains("media"))
      return;

    const shield = document.createElement("div");
    shield.className = "deferred-media__iframe-swipe-shield";
    shield.setAttribute("aria-hidden", "true");

    let removed = false;
    const fallbackTimer = setTimeout(onDone, 8000);

    const removeShield = () => {
      if (removed) return;
      removed = true;
      clearTimeout(fallbackTimer);
      iframe.removeEventListener("load", onDone);
      iframe.removeEventListener("error", onDone);
      requestAnimationFrame(() => {
        shield.remove();
        const sw = this.closest(".js-media-list")?.swiper;
        if (sw) {
          sw.params.noSwiping = false;
          try {
            sw.update();
          } catch (_) {}
        }
      });
    };

    function onDone() {
      removeShield();
    }

    iframe.addEventListener("load", onDone);
    iframe.addEventListener("error", onDone);

    this.appendChild(shield);
  }

  _resetDeferredContent() {
    this.querySelector("video, iframe")?.remove();
    this.querySelector(".deferred-media__iframe-swipe-shield")?.remove();
    this.removeAttribute("loaded");
    const swiper = this.closest(".swiper")?.swiper;
    if (swiper) {
      swiper.params.noSwiping = false;
      try {
        swiper.update();
      } catch (_) {}
    }
  }

  loadContent() {
    if (this.getAttribute("loaded")) return;

    const template = this.querySelector("template");
    if (!template || !template.content.firstElementChild) return;

    const content = document.createElement("div");
    content.appendChild(template.content.firstElementChild.cloneNode(true));

    if (typeof window.pauseAllMedia === "function") window.pauseAllMedia();

    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (this.getAttribute("data-autoplay")) {
            let playPromise = entry.target.play();
            if (playPromise !== undefined) {
              playPromise.then((_) => {}).catch(() => {});
            }
          }
        } else {
          entry.target.pause();
        }
      });
    });

    let deferredElement;
    try {
      deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
    } catch (_) {
      // loaded was never set, so poster stays visible and clickable
      return;
    }

    if (!deferredElement) return;

    // Set loaded only after content is successfully in the DOM
    this.setAttribute("loaded", true);

    if (deferredElement?.nodeName === "VIDEO") {
      deferredElement.addEventListener(
        "error",
        () => this._resetDeferredContent(),
        { once: true },
      );

      const playPromise = deferredElement.play?.();

      if (this.classList.contains("video-section__media")) {
        if (playPromise !== undefined) {
          playPromise
            .then((_) => {})
            .catch((err) => {
              console.warn(
                "[DeferredMedia] video-section video.play() rejected:",
                err?.name,
                err?.message,
              );
            });
        }

        videoObserver.observe(deferredElement);
      } else if (playPromise !== undefined) {
        playPromise.catch((err) => {
          console.warn(
            "[DeferredMedia] video.play() rejected:",
            err?.name,
            err?.message,
          );
        });
      }
    }

    if (deferredElement?.nodeName === "IFRAME") {
      this.attachIframeCarouselShield(deferredElement);
      deferredElement.addEventListener(
        "error",
        () => this._resetDeferredContent(),
        { once: true },
      );
    }

    const _swiperInst = this.closest(".swiper")?.swiper;
    if (_swiperInst?.slides) {
      const _activeSlide = _swiperInst.slides[_swiperInst.activeIndex];
      const _mv = _activeSlide?.querySelector("model-viewer");
      if (_mv && !_mv.classList.contains("shopify-model-viewer-ui__disabled")) {
        _swiperInst.params.noSwiping = true;
        _swiperInst.params.noSwipingClass = "swiper-slide";
      }
      _swiperInst.update();
    } else {
      // Swiper not yet initialized — poll until the instance is assigned, then update.
      // MutationObserver on 'swiper-initialized' class fires before el.swiper is set,
      // so checking el.swiper in the callback always sees null and silently drops the update.
      const _swiperEl = this.closest(".js-media-list");
      if (_swiperEl) {
        console.log(
          "[DeferredMedia] loadContent: Swiper not yet initialised, waiting…",
          this,
        );
        let _attempts = 0;
        const _waitForSwiper = () => {
          if (_swiperEl.swiper) {
            console.log(
              "[DeferredMedia] Swiper now available after",
              _attempts,
              "poll(s), calling update()",
            );
            try {
              _swiperEl.swiper.update();
            } catch (_) {}
            return;
          }
          if (++_attempts < 60) {
            setTimeout(_waitForSwiper, 100);
          } else {
            console.warn(
              "[DeferredMedia] Swiper never became available after 6s — giving up",
            );
          }
        };
        _waitForSwiper();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      if (
        typeof publish === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        publish(PUB_SUB_EVENTS.variantChange, {
          data: { variant: this.currentVariant },
        });
      }
      if (!this.closest("floated-form")) {
        this.updateMedia();
      }
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll(".js-radio-colors"));

    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    ).concat(
      fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked,
        ).value;
      }),
    );
  }

  updateMasterId() {
    if (this.variantData || this.querySelector('[type="application/json"]')) {
      this.currentVariant = this.getVariantData().find((variant) => {
        this.options.sort();
        variant.options.sort();

        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  isHidden(elem) {
    const styles = window.getComputedStyle(elem);
    return styles.display === "none" || styles.visibility === "hidden";
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const swiperWrappers = document.querySelectorAll(".product__media-wrapper");

    swiperWrappers.forEach((elem) => {
      if (!this.isHidden(elem)) {
        const newMedia = elem.querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
        );

        elem
          .querySelector(".js-media-list")
          .swiper.slideTo(
            elem
              .querySelector(".js-media-list")
              .swiper.slides.indexOf(newMedia),
          );
      }
    });
  }

  updateURL() {
    if (!this.classList.contains("featured-product-radios")) {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        if (input.tagName === "OPTION") {
          input.innerText = input.getAttribute("value");
        } else if (input.tagName === "INPUT") {
          input.classList.remove("disabled");
        }
      } else {
        if (input.tagName === "OPTION") {
          input.innerText =
            window.variantStrings.unavailable_with_option.replace(
              "[value]",
              input.getAttribute("value"),
            );
        } else if (input.tagName === "INPUT") {
          input.classList.add("disabled");
        }
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        );
        const badgeSource = html.getElementById(
          `product_badge_styles-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const badgeDestination = document.getElementById(
          `product_badge_styles-${this.dataset.section}`,
        );
        const variantDescSource = html.getElementById(
          `variantShortDesc-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const variantDescDestination = document.getElementById(
          `variantShortDesc-${this.dataset.section}`,
        );
        const variantSaleDescSource = html.getElementById(
          `variantSaleDesc-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const variantSaleDescDestination = document.getElementById(
          `variantSaleDesc-${this.dataset.section}`,
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden"),
          );
        }
        if (variantDescSource && variantDescDestination) {
          variantDescDestination.innerHTML = variantDescSource.innerHTML;
          variantDescDestination.classList.toggle(
            "visibility-hidden",
            variantDescSource.classList.contains("visibility-hidden"),
          );
        }
        if (variantSaleDescSource && variantSaleDescDestination) {
          variantSaleDescDestination.innerHTML =
            variantSaleDescSource.innerHTML;
          variantSaleDescDestination.classList.toggle(
            "visibility-hidden",
            variantSaleDescSource.classList.contains("visibility-hidden"),
          );
        }
        if (badgeSource && badgeDestination) {
          badgeDestination.innerHTML = badgeSource.innerHTML;
          badgeDestination.classList.toggle(
            "visibility-hidden",
            badgeSource.classList.contains("visibility-hidden"),
          );
        }

        const sectionId = this.dataset.originalSection || this.dataset.section;

        const destMainProduct = document.getElementById(
          `MainProduct-${this.dataset.section}`,
        );
        const mainShowAll =
          destMainProduct?.dataset?.showAllVariantImages === "true";

        // When every variant's media is already rendered, the server-returned
        // media set is identical and swapping innerHTML causes a visible flash
        // for no benefit. updateMedia() already slides the main swiper to the
        // correct featured media, so skip the DOM replacement in that case.
        if (!mainShowAll) {
          const sourceMainProduct = html.getElementById(
            `MainProduct-${sectionId}`,
          );
          if (sourceMainProduct && destMainProduct) {
            const toDestroy = destMainProduct.querySelectorAll(
              ".js-media-list, .js-media-sublist",
            );
            toDestroy.forEach((el) => {
              if (el.swiper && typeof el.swiper.destroy === "function") {
                try {
                  el.swiper.destroy(true, true);
                } catch (_) {}
              }
            });

            const wrapperSelectors = [
              ".product__media-wrapper.product__media-wrapper--mobile",
              ".product__media-wrapper:not(.product__media-wrapper--mobile)",
            ];
            wrapperSelectors.forEach((sel) => {
              const src = sourceMainProduct.querySelector(sel);
              const dst = destMainProduct.querySelector(sel);
              if (src && dst) {
                dst.innerHTML = src.innerHTML;
              }
            });

            if (typeof subSliderInit === "function") subSliderInit(true);
            if (typeof sliderInit === "function") sliderInit(true);
          }
        }

        const drawerRoot = document.querySelector(
          `[data-product-image-drawer-root="${sectionId}"]`,
        );
        const drawerShowAll =
          drawerRoot?.dataset?.pidShowAllVariantImages === "true";

        if (drawerRoot && !drawerShowAll) {
          const newDrawerRoot = html.querySelector(
            `[data-product-image-drawer-root="${sectionId}"]`,
          );
          if (newDrawerRoot && drawerRoot.__pid) {
            drawerRoot.innerHTML = newDrawerRoot.innerHTML;
            if (typeof drawerRoot.__pid.reinit === "function") {
              drawerRoot.__pid.reinit();
            }
          }
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        affirm.ui.refresh();
        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === "",
          );

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button?.querySelector('[name="add"]');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    this.toggleAddButton(true, window.variantStrings.unavailable);
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      /*fieldset.querySelectorAll('input:not(.disabled) + label').forEach(elem => {
        elem.style.opacity = '0.5';
        elem.style.pointerEvents = 'none';
      });*/

      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

if (window.location.pathname.includes("/collections/")) {
  document.addEventListener(
    "click",
    function (event) {
      const anchor = event.target.closest("a.menu-drawer__menu-item");

      if (anchor && anchor.closest("ul.menu-drawer__menu")) {
        const details = anchor.closest("details.menu-drawer-container");

        if (details && details.classList.contains("menu-opening")) {
          details.classList.remove("menu-opening");
          details.removeAttribute("open");
        }
      }
    },
    true,
  );
}

/*
 * Richpanel accessibility
 * - Remember whichever element opens Richpanel.
 * - Focus Richpanel when it opens.
 * - Restore focus to its opener when it closes.
 */

document.addEventListener("DOMContentLoaded", () => {
  let richpanelTrigger = null;

  const iframeSelector = "#richpanel_messenger_iframe";
  const bodyOpenedClass = "rp-messenger-active";

  const triggerSelector = [
    ".richpanel-micro",
    "[data-richpanel-header-caller]",
  ].join(",");

  function isRichpanelOpen() {
    return document.body.classList.contains(bodyOpenedClass);
  }

  function updateHeaderCallerState(isOpen) {
    document
      .querySelectorAll("[data-richpanel-header-caller]")
      .forEach((caller) => {
        caller.setAttribute("aria-expanded", String(isOpen));
      });
  }

  function getFirstFocusableElement(iframeDocument) {
    const iframeWindow = iframeDocument.defaultView;

    if (!iframeWindow) return null;

    const focusableSelector = [
      "[autofocus]",
      "button:not([disabled])",
      "a[href]",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      '[tabindex]:not([tabindex="-1"])',
    ].join(",");

    return (
      Array.from(iframeDocument.querySelectorAll(focusableSelector)).find(
        (element) => {
          if (!(element instanceof iframeWindow.HTMLElement)) {
            return false;
          }

          const styles = iframeWindow.getComputedStyle(element);

          return (
            styles.display !== "none" &&
            styles.visibility !== "hidden" &&
            styles.opacity !== "0" &&
            element.getClientRects().length > 0
          );
        },
      ) ?? null
    );
  }

  function focusRichpanelIframe() {
    if (!isRichpanelOpen()) return false;

    const iframe = document.querySelector(iframeSelector);

    if (!(iframe instanceof HTMLIFrameElement)) {
      return false;
    }

    try {
      const iframeDocument = iframe.contentDocument;

      if (iframeDocument) {
        const focusTarget = getFirstFocusableElement(iframeDocument);

        if (focusTarget) {
          focusTarget.focus({
            preventScroll: true,
          });

          return iframeDocument.activeElement === focusTarget;
        }
      }
    } catch {
      /*
       * Richpanel is cross-origin, so its internal
       * elements cannot be selected directly.
       */
    }

    iframe.contentWindow?.focus();

    return document.activeElement === iframe;
  }

  function fixRichpanelIframeAccessibility() {
    const iframe = document.querySelector(iframeSelector);

    if (!(iframe instanceof HTMLIFrameElement)) {
      return false;
    }

    iframe.removeAttribute("role");

    if (!iframe.hasAttribute("aria-label")) {
      iframe.setAttribute("aria-label", "Richpanel Messenger");
    }

    return true;
  }

  function focusRichpanelAfterOpen() {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        if (isRichpanelOpen()) {
          focusRichpanelIframe();
        }
      });
    });
  }

  function restoreTriggerFocus() {
    if (
      richpanelTrigger instanceof HTMLElement &&
      document.contains(richpanelTrigger)
    ) {
      richpanelTrigger.focus({
        preventScroll: true,
      });
    }

    richpanelTrigger = null;
  }

  /*
   * Capture the opener before Richpanel handles the click.
   *
   * The new header button matches because it has both:
   * - .richpanel-micro
   * - [data-richpanel-header-caller]
   */
  document.addEventListener(
    "click",
    (event) => {
      if (!(event.target instanceof Element)) return;

      const trigger = event.target.closest(triggerSelector);

      if (!(trigger instanceof HTMLElement)) return;

      richpanelTrigger = trigger;
    },
    true,
  );

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (
        mutation.type !== "attributes" ||
        mutation.attributeName !== "class" ||
        mutation.target !== document.body
      ) {
        continue;
      }

      const previousClasses = new Set(
        (mutation.oldValue ?? "").split(/\s+/).filter(Boolean),
      );

      const wasOpen = previousClasses.has(bodyOpenedClass);

      const isOpen = isRichpanelOpen();

      if (!wasOpen && isOpen) {
        updateHeaderCallerState(true);
        fixRichpanelIframeAccessibility();
        focusRichpanelAfterOpen();
      }

      if (wasOpen && !isOpen) {
        updateHeaderCallerState(false);
        restoreTriggerFocus();
      }
    }
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ["class"],
    attributeOldValue: true,
  });

  updateHeaderCallerState(isRichpanelOpen());
});

function fixSearchspringMinMaxPriceAccessibility() {
  document
    .querySelectorAll(".ss__facet__inputs .facets__price-wrapper")
    .forEach((wrapper) => {
      const inputs = wrapper.querySelectorAll('input[type="number"]');

      if (inputs[0]) {
        inputs[0].setAttribute("aria-label", "Minimum price");
      }

      if (inputs[1]) {
        inputs[1].setAttribute("aria-label", "Maximum price");
      }
    });
}

function fixSearchspringCardAccessibility() {
  document
    .querySelectorAll(".ss__result.collection-product-card")
    .forEach((productCard) => {
      const productTitleLink = productCard.querySelector(".card__title a");

      const overlayLink = productCard.querySelector(
        '.card-wrapper__link--overlay[aria-label="Product link"]',
      );

      if (!productTitleLink || !overlayLink) return;

      const productName = productTitleLink.textContent.trim();

      if (productName) {
        overlayLink.setAttribute("aria-label", productName);
      }
    });
}
function fixSearchspringShowMoreAccessibility() {
  document
    .querySelectorAll(".ss__show-more__link.facets__showMore")
    .forEach((showMore) => {
      if (showMore.dataset.accessibilityFixed === "true") return;

      showMore.setAttribute("role", "button");
      showMore.setAttribute("tabindex", "0");

      const updateExpanded = () => {
        const collapsed = showMore
          .closest(".ss__show-more")
          ?.classList.contains("ss__collapsed");

        showMore.setAttribute("aria-expanded", String(!collapsed));
      };

      updateExpanded();

      showMore.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          showMore.click();
        }
      });

      showMore.addEventListener("click", () => {
        requestAnimationFrame(updateExpanded);
      });

      showMore.dataset.accessibilityFixed = "true";
    });
}

function fixSearchspringAutocompleteAccessibility() {
  document
    .querySelectorAll(".ss__autocomplete__terms__options")
    .forEach((list) => {
      list
        .querySelectorAll(":scope > .ss__autocomplete__terms__option")
        .forEach((option) => {
          option.setAttribute("role", "listitem");
        });
    });
}
function fixSearchspringRecommendationHeadingAccessibility() {
  document
    .querySelectorAll("h3.ss__title--recommendation")
    .forEach((heading) => {
      const replacement = document.createElement("h2");

      // Preserve all attributes/classes Searchspring put on it
      Array.from(heading.attributes).forEach((attribute) => {
        replacement.setAttribute(attribute.name, attribute.value);
      });

      // Move the existing contents rather than recreating them
      while (heading.firstChild) {
        replacement.appendChild(heading.firstChild);
      }

      heading.replaceWith(replacement);
    });
}

function fixSearchspringDuplicateQuickAddIds() {
  document
    .querySelectorAll(".ss__result.ss__result--item")
    .forEach((productCard, index) => {
      const button = productCard.querySelector(
        ".static_add-to-cart_button[id][aria-labelledby]",
      );

      if (!button) return;

      const oldId = button.id;
      const newId = `${oldId}-${index}`;

      button.id = newId;

      const labelledBy = button
        .getAttribute("aria-labelledby")
        ?.split(/\s+/)
        .map((id) => (id === oldId ? newId : id))
        .join(" ");

      if (labelledBy) {
        button.setAttribute("aria-labelledby", labelledBy);
      }
    });
}

// really cool how searchspring needs all these...
function fixSearchspringAccessibility() {
  fixSearchspringMinMaxPriceAccessibility();
  fixSearchspringCardAccessibility();
  fixSearchspringShowMoreAccessibility();
  fixSearchspringAutocompleteAccessibility();
  fixSearchspringRecommendationHeadingAccessibility();
  fixSearchspringDuplicateQuickAddIds();
}

fixSearchspringAccessibility();

const searchspringAccessibilityObserver = new MutationObserver(() => {
  fixSearchspringAccessibility();
});

searchspringAccessibilityObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

// Loox
function fixLooxTrustBadgeAccessibility() {
  document.querySelectorAll("loox-trust-badge-widget").forEach((widget) => {
    if (widget.dataset.accessibilityFixed === "true") return;

    const shadowRoot = widget.shadowRoot;
    if (!shadowRoot) return;

    const fixRaters = () => {
      shadowRoot
        .querySelectorAll(
          ".loox-trust-badge-widget-ratings__raters[aria-label]",
        )
        .forEach((raters) => {
          raters.removeAttribute("aria-label");
        });
    };

    fixRaters();

    const observer = new MutationObserver(fixRaters);

    observer.observe(shadowRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-label"],
    });

    widget.dataset.accessibilityFixed = "true";
  });
}

customElements
  .whenDefined("loox-trust-badge-widget")
  .then(fixLooxTrustBadgeAccessibility);

new MutationObserver(fixLooxTrustBadgeAccessibility).observe(document.body, {
  childList: true,
  subtree: true,
});
